<script>

import {mapGetters} from 'vuex';
import Loader from '@components/loader';
import {brand} from '@brand/settings';
import Raven from 'raven-js';
import {createClient} from 'contentful';
import moment from 'moment';

export default {
	name: 'App',
	components: {
		Loader
	},
	data() {
		return {
			modalShow: false,
			logOut: false
		};
	},
	computed: {
		allRoutes() {
			return this.$router.options.routes.filter(item => item.name !== 'Register' && item.name !== 'Login');
		},
		...mapGetters({
			isUserLoggedIn: 'isUserLoggedIn'
		})
	},
	created() {

		/* Contentful configuration */
		const production = {
			accessToken: '0d690cb0b01aea696b3d7aac852d3421e7edb16da2345a4e183888fddf816b4e',
			host: 'cdn.contentful.com'
		};

		const dev = {
			accessToken: '83133311acbec7cb192ca8001ab13faf86073460b443b6674fb82377529416bc',
			host: 'preview.contentful.com'
		};

		const contentful = {
			space: 'rhrgxu3unfam'
		};

		/* Contentful config */
		const config = Object.assign(contentful, (process.env.NODE_ENV === 'production') ? production : dev);

		/* Contentful client */
		const contentfulClient = createClient(config);

		const status = {
			content_type: 'status',
			'fields.env': (process.env.NODE_ENV === 'production') ? 'production' : 'development'
		};

		contentfulClient.getEntries(status).then(brandStatusData => {

			const brandStatuses = brandStatusData.items[0].fields;

			if (brandStatuses[brand]) {

				this.$store.dispatch('setOffline', false);

				/* Contentful entries filter */
				const filter = {
					content_type: 'restaurant',
					'fields.brand': brand,
					include: 3,
					order: 'fields.name',
					limit: 300,
					'fields.testLab': false
				};

				/* Only show Test Labs on Dev environment */
				if (process.env.NODE_ENV !== 'production') {
					filter['fields.testLab'] = true;
				}

				const uiCopyFilter = {
					'content_type': 'uiCopy',
					'include': 3
				}

				/* Get UI copy from contentful and add to Vuex store */
				contentfulClient.getEntries(uiCopyFilter).then(data => {
					const uiCopyArray = data.items;
					let uiCopy = null;

					uiCopyArray.forEach((arrayItem) => {
						if (arrayItem.fields.brand === brand) {
							return uiCopy = arrayItem.fields;
						}
					});

					/* Set default UI copy if brand doesn't have a contentful container */
					if (!uiCopy) {
						uiCopyArray.forEach((arrayItem) => {
							if (arrayItem.fields.brand === 'default') {
								return uiCopy = arrayItem.fields;
							}
						});
					}

					/* A backup for if the default contentful container is deleted to prevent the app from crashing */
					if (!uiCopy) {
						uiCopy = {
							name: 'Backup Ui Copy',
							brand: 'backup',
							locationPageHeading: '40% will be taken off your starters, mains and desserts.',
							locationPageSubHeading: 'Thanks for using Click and Collect!',
							checkoutPageMessage: '40% has been taken off your starters, mains and desserts! Thanks for using Click and Collect!'
						}
					}

					this.$store.dispatch('setUiCopy', uiCopy);
				});

				/* Get contentful entries */
				contentfulClient.getEntries(filter).then(data => {

					/* Get locations from Contentful and add them to Vuex for hydration */
					const timestamp = moment(this.$store.state.user.location.timestamp);
					const current = moment(new Date());
					const difference = current.diff(timestamp, 'minutes');

					this.$store.state.user.location.difference = difference;

					/* Not cached! Check user has not already recieved locations within the last 15 mins or has chosen a different brand */
					if (!this.$store.state.user.location.timestamp || difference > 14 || this.$store.state.brand !== brand) {

						/* Set brand */
						this.$store.dispatch('setBrand', brand);

						/* Save locations to window for later processing (MUCH quicker than Vuex + localStorage) */
						window.contentfulItems = data.items;

						/* Set breadcrumb for cached locations */
						Raven.captureBreadcrumb({
							message: 'User has fresh locations from Zonal',
							category: 'location',
							data: {
								locationsLength: window.contentfulItems.length
							}
						});

						/* Emit locationsUpdated event to components */
						this.$root.$emit('locationsUpdated');

					} else {

						/* Set breadcrumb for cached locations */
						Raven.captureBreadcrumb({
							message: 'User has cached locations',
							category: 'location',
							data: {
								locationsLength: this.$store.state.locations.length
							}
						});

						const updatedLocations = [];

						/* Update cached locations with fresh data from contentful - allows instant enable/disable */
						for (let i = 0, len = this.$store.state.locations.length; i < len; i++) {

							const cachedLocation = this.$store.state.locations[i];

							/* Match contentful + zonal locations by ID */
							const contentfulLocation = data.items.filter((location) => {
								return (location.fields.zonalSiteId === cachedLocation.id);
							})[0];

							const updatedLocation = cachedLocation;

							/* Enable/disable venue */
							updatedLocation.enabled = contentfulLocation.fields.enabled;
							updatedLocations.push(updatedLocation);
						}

						/* Add updated (enabled/disabled) locations to Vuex */
						this.$store.dispatch('updateLocations', updatedLocations);

						/* Emit locationsUpdated event to components */
						this.$root.$emit('locationsUpdated');
					}

					/* User gets pushed to Start page around here */
				});

			} else {

				this.$store.dispatch('setOffline', true);

				/* Brand is offline - push to sorry page */
				this.$router.push({name: 'Offline'});
			}
		});
	}
};
</script>

<template>
	<div class="_">
		<div id="app">

			<transition name="fade" mode="out-in">
				<router-view class="view"></router-view>
			</transition>

			<portal-target name="mobile-footer" v-if="$store.state.breakpoint === 'initial'" />

		</div>
		<portal-target name="modal"></portal-target>
	</div>
</template>

<style src="@/css/app.scss" lang="scss"></style>
<style src="@brand/css/theme.scss" lang="scss"></style>



// WEBPACK FOOTER //
// src/vue/templates/app.vue